<template>
  <transition appear :enter-active-class="transition.classes.enter" :leave-active-class="transition.classes.leave">
    <div>
      <RecruitmentSmallRecap v-if="candidates.length > 0" :recruitment="recruitment" @open-recruitment-recap="openRecruitmentRecap" />

      <h3 v-if="recruitment.isFilled() || recruitment.isExpired()" class="text-positive text-center q-pt-md">
        <span>{{ $tc("ETAB.PAGES.CANDIDATE.@CHOSEN_CANDIDATES_TITLE_TEMPORARY", selectedCandidatesAmount) }}</span>
      </h3>

      <transition-group tag="div" name="candidate-list">
        <!-- Selected Candidates -->
        <CandidateTemporaryCard
          v-for="candidate in candidates"
          :id="candidate.getId()"
          :key="candidate.getId() + '_current'"
          :candidate="candidate"
          :recruitment="recruitment"
          :can-ignore="false"
          :can-contact="true"
          @go-to-profile="goToProfile"
          @contact-candidate="onContactCandidate"
        />
        <!-- Selected Candidates who canceled -->
        <CandidateTemporaryCard
          v-for="candidate in canceledCandidates"
          :id="candidate.getId()"
          :key="candidate.getId() + '_canceled'"
          :candidate="candidate"
          :recruitment="recruitment"
          :can-ignore="false"
          :can-contact="false"
          @go-to-profile="goToProfile"
        />
      </transition-group>

      <NoCandidate
        v-if="candidates.length === 0 && canceledCandidates.length === 0"
        :img="placeholderImg"
        :title="$t('ETAB.PAGES.CANDIDATE.@NO_TEMPORARY_CANDIDATES')"
      />
    </div>
  </transition>
</template>

<script setup>
  import { GETTER_RECRUITMENT_GET_CURRENT, ACTION_DASHBOARD_OPEN_RECRUITMENT_RECAP_MODAL } from "@etab/stores/types";
  import { useRecruitmentStore } from "@etab/stores/recruitment";
  import { useDashboardStore } from "@etab/stores/dashboard";
  import { computed, onMounted } from "vue";
  import { useRecruitmentCandidate } from "@etab/composables";
  import { useTransition } from "@core/composables";

  import CandidateTemporaryCard from "@etab/components/candidates/CandidateTemporary.card.vue";
  import NoCandidate from "@etab/components/candidates/NoCandidate.functional.vue";
  import RecruitmentSmallRecap from "@etab/components/recruitments/detail/RecruitmentSmallRecap.component";

  import placeholderImg from "@etab/assets/img/placeholders/candidate_chosen_placeholder.png";

  const { transition } = useTransition();
  const { $_goToProfileFromMultiCandidatesMERDemand, $_goToMissionFromTemporaryDemand, $_scrollToPreviouslyOpenedExtra, $_onContactCandidate } =
    useRecruitmentCandidate();
  const recruitmentStore = useRecruitmentStore();
  const dashboardStore = useDashboardStore();

  // Computed
  const candidates = computed(() => {
    return recruitment.value.getSelectedCandidates();
  });

  const canceledCandidates = computed(() => {
    return recruitment.value.getCanceledCandidates();
  });

  const selectedCandidatesAmount = computed(() => {
    return recruitment.value.getSelectedCandidates().length;
  });

  const recruitment = computed(() => {
    return recruitmentStore[GETTER_RECRUITMENT_GET_CURRENT];
  });

  // Methods
  const openRecruitmentRecap = function () {
    dashboardStore[ACTION_DASHBOARD_OPEN_RECRUITMENT_RECAP_MODAL]({ recap: recruitment.value });
  };

  const onContactCandidate = async function ({ candidate }) {
    $_onContactCandidate({ candidate });
  };

  const goToProfile = function ({ candidate }) {
    $_goToMissionFromTemporaryDemand({ candidate });
  };

  // Mounted
  onMounted(() => {
    $_scrollToPreviouslyOpenedExtra();
  });
</script>
